// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__8KlCL","ellipsis":"styles_ellipsis__mZx0S","text2AndMoreLines":"styles_text2AndMoreLines__CvSXP","tooltipTrigger":"styles_tooltipTrigger__QkOQj"};